// Chinese translations
export const chineseTranslations = {
  header: {
    title: "合作与伙伴关系页面",
    subtitle: "可靠性。创新。协作。",
    breadcrumb: {
      home: "首页",
      current: "合作与伙伴关系页面"
    }
  },
  introduction: {
    paragraph1: "成立于1998年，Business Automation Limited 成为孟加拉国最早的IT支持服务（ITES）提供商之一，其发展源于一个大胆的愿景：为组织提供符合本地需求的世界级数字化解决方案。 在过去27年中，我们已成长为电子政务创新领域的可信赖企业，为孟加拉国及其他地区的 300多家公私部门客户 提供服务。",
    paragraph2: "我们的解决方案——从企业软件和市民服务门户到物联网（IoT）驱动的系统和工作流自动化——能够提升服务交付效率、提高运营效率，并推动包容性的数字化发展。 公司总部位于孟加拉国达卡，我们通过 内部研发、现代化的UI/UX实验室 以及 完善的售后支持体系 提供端到端的平台服务。我们的多学科团队，由女性和年轻专业人士组成，开发了具有重大影响力的系统，包括 智能自助终端、客户服务管理工具 以及为数百万人提供服务的 国家级自动化平台。",
    paragraph3: "作为 ISO 9001、ISO 20000 和 ISO 27000 认证的组织，我们在每一个项目中都追求卓越，无论是本地中小企业还是国家级的数字化转型计划。我们的包容性工作环境通过 导师辅导、灵活工作时间以及 AI/RPA 培训 赋能女性和年轻专业人才，培养出一支 反映孟加拉国多样化人才 的团队。",
    paragraph4: "无论是支持政府机构，还是与全球组织合作，Business Automation 都能提供 合适的人才、工具和愿景，将挑战转化为机遇。"
  },
  howWeCanHelp: {
    title: "我们如何提供帮助",
    subtitle: "选择我们作为您在孟加拉国的本地合作伙伴时，您可以获得以下支持：",
    services: [
      {
        title: "现场支持：",
        description: "时差、文化差异和语言障碍会增加国际业务的复杂性。为此，我们通过 在孟加拉国为您的项目提供本地支持，帮助您解决这些问题，使业务顺利开展。"
      },
      {
        title: "全国覆盖：",
        description: "无论是城市还是农村地区，我们都能够确保 在全国范围内顺利执行项目，不仅限于首都地区。"
      },
      {
        title: "在孟加拉国法律与治理框架下的工作能力：",
        description: "遵守法律法规对国际业务至关重要。我们在这些领域的专业知识能够 简化流程，缩短处理时间，确保项目合规高效开展。"
      },
      {
        title: "验证的专业能力：",
        description: "我们能够将 全球解决方案与本地技术、用户界面及基础设施无缝整合，确保 全球系统与本地系统之间的顺畅连接与集成。"
      },
      {
        title: "数据输入、地图制作与可扩展解决方案：",
        description: "我们提供 精准的数据输入与处理、地理映射、区域创建及地图平台整合服务，同时提供 可扩展的IT基础设施，以支持业务增长。"
      },
      {
        title: "维护与运营支持：",
        description: "我们提供 主动监控、快速问题解决、全面的年度维护合同（AMC） 以及 提供多语言支持的全天候24/7技术服务台，以将系统停机时间降至最低。例如，我们还为 BCIC、BIDA、A2i、RAJUK 和 JICA 提供持续的技术支持。"
      },
      {
        title: "培训与能力建设：",
        description: "我们开展 结构化培训计划（线下与线上），以推动产品采纳，并赋能您的本地团队和分销商，使其掌握成功所需的知识。例如，我们曾为 JICA、RAJUK、A2i、BIDA、UNDP、世界银行、BEPRC、BTRC、BHTPA、BCSIR、BASIS 等项目提供过工作坊培训。"
      },
      {
        title: "包容性文化：",
        description: "我们拥有 超过100名成员的团队，其中 25%为女性和年轻专业人士，通过多样性推动创新。"
      }
    ]
  },
  // trustedPartner: {
  //   title: "是什么让我们成为值得信赖的合作伙伴",
  //   subtitle: "简单地说，您的需求是我们的优先考虑，我们超越基本的一刀切解决方案。与我们合作，您将获得专门为您定制的技术解决方案。此外，我们拥有：",
  //   trackRecordTitle: "我们的业绩记录说明了一切：",
  //   stats: [
  //     {
  //       number: "27+年",
  //       title: "孟加拉国领先的ITES公司，拥有近三十年的传承。"
  //     },
  //     {
  //       number: "300+",
  //       title: "受到300多个公共部门实体的信任，包括30多个部委"
  //     },
  //     {
  //       number: "10+",
  //       title: "参与10多个国家/地方电子政务平台"
  //     }
  //   ],
  //   trackRecord: [
  //     {
  //       text: "与客户接触进行服务和流程简化。"
  //     },
  //     {
  //       text: "孟加拉国最大的第三方集成之一的经验",
  //       linkText: "（了解更多）"
  //     },
  //     {
  //       text: "在不同政府实体中成功实施公共数据分析的记录。（如SDG跟踪、A2i仪表板、能源管理、公共服务管理等）"
  //     },
  //     {
  //       text: "管理服务器并在不同数据中心提供devOps服务，包括国家数据中心和4级数据中心。",
  //       linkText: "（了解更多）"
  //     },
  //     {
  //       text: "大规模数据管理和数据迁移经验（拥有2100万条记录、数据大小175+ TB的最大经验）"
  //     },
  //     {
  //       text: "使用我们的培训平台提供全国性培训服务的经验。"
  //     },
  //     {
  //       text: "记录数字化经验（如数据录入、文档和地图扫描）以成功推出项目。",
  //       linkText: "（了解更多）"
  //     },
  //     {
  //       text: "通过我们的客户服务平台根据项目需要提供技术支持服务的经验",
  //       linkText: "（了解更多）"
  //     }
  //   ]
  // },
  // trackRecord: {
  //   title: "我们的记录",
  //   subtitle: "在数字解决方案交付方面的卓越表现",
  //   items: [
  //     {
  //       icon: "/png/pc_1.png",
  //       alt: "参与",
  //       text: "与客户接触，简化服务和流程。",
  //       hasLink: false,
  //     },
  //     {
  //       icon: "/png/pc_2.png",
  //       alt: "API集成",
  //       text: "在孟加拉国拥有最大第三方集成经验之一",
  //       hasLink: true,
  //       linkText: "（了解更多）",
  //       linkUrl: "/services/api-integration",
  //     },
  //     {
  //       icon: "/png/pc_3.png",
  //       alt: "分析",
  //       text: "在不同政府实体中成功实施公共数据分析的记录（如SDG跟踪、A2i仪表板、能源管理、公共服务管理等）",
  //       hasLink: false,
  //     },
  //     {
  //       icon: "/png/pc_4.png",
  //       alt: "服务器管理",
  //       text: "管理服务器并提供托管在不同数据中心的DevOps服务，包括国家数据中心和四级数据中心。",
  //       hasLink: true,
  //       linkText: "（了解更多）",
  //       linkUrl: "/services/devops-services",
  //     },
  //     {
  //       icon: "/png/pc_5.png",
  //       alt: "数据管理",
  //       text: "大规模数据管理和数据迁移经验（最大经验为2100万+记录，数据大小175+ TB）",
  //       hasLink: false,
  //     },
  //     {
  //       icon: "/png/pc_6.png",
  //       alt: "培训",
  //       text: "使用我们的培训平台提供全国性培训服务的经验。",
  //       hasLink: false,
  //     },
  //     {
  //       icon: "/png/pc_7.png",
  //       alt: "数字化",
  //       text: "记录数字化经验（如数据录入、文档和地图扫描）以成功推出项目。",
  //       hasLink: true,
  //       linkText: "（了解更多）",
  //       linkUrl: "/services/record-digitization-services",
  //     },
  //     {
  //       icon: "/png/pc_8.png",
  //       alt: "支持",
  //       text: "通过我们的客户服务平台为项目提供技术支持服务的经验",
  //       hasLink: true,
  //       linkText: "（了解更多）",
  //       linkUrl: "/services/tech-support-services",
  //     },
  //   ],
  // },
  // collaboration: {
  //   title: "我们如何与您合作",
  //   subtitle: "在动态多样的商业环境中，根据手头项目的需求需要不同形式的合作伙伴关系。我们通过为您提供潜在合作模式的选择来适应这种情况，例如：",
  //   modes: [
  //     {
  //       title: "技术交付合作伙伴",
  //       description: "为顾问或项目提供完整的专业知识和无缝集成。"
  //     },
  //     {
  //       title: "联合提案",
  //       description: "共同创建获胜的投标书，用于政府RFP，从G2P到健康和教育平台。"
  //     },
  //     {
  //       title: "技术许可",
  //       description: "为您的举措许可和扩展我们的平台。"
  //     },
  //     {
  //       title: "外包团队",
  //       description: "为有时间限制的任务提供专门的开发或支持。"
  //     },
  //     {
  //       title: "框架协议",
  //       description: "支持长期国家推广或多年后与L&T的技能转移任务。"
  //     }
  //   ],
  //   conclusion: "我们一直鼓励与来自各个领域的潜在客户建立合作伙伴关系，无论是在我们的孟加拉国本土还是在全球范围内。因此，随着我们迈向新时代，我们期待通过我们值得信赖的专家团队在全球范围内提供更多高质量、定制的技术解决方案。"
  // }
  contact: {
    inquiryText: "欲了解更多信息，请访问并联系我们",
    buttonText: "联系我们",
    hashtags: "#商业自动化 #孟加拉国IT公司 #数字化转型 #全球合作伙伴 #电子政务 #物联网解决方案 #工作流程自动化 #国际商务支持 #女性赋能 #ISO认证企业"
  },
  feedback: {
    question: "此信息对您有帮助吗？",
    yes: "是",
    no: "否",
    thankYou: "谢谢您的反馈！",
    modalTitle: "我们很抱歉听到这个消息。请告诉我们如何改进。",
    placeholder: "文本框 - 最多250个字符",
    submit: "提交"
  }
};